import Model from "./base/model";

class cteFile extends Model{
    resourceName() {
        return "cte_files";
    }

    fields() {
        return {
          cte_path: "",
          cte_name: "",
          number: "",
          shipping_price: "",
          collection_fee: "",
          gris: "",
          ad_valorem: "",
          toll: "",
          icms: "",
          iss: "",
          is_additional: "",
          cte_pdf:"",
          created_at: "",
          request_number: "",
        }
    }
}

export default new cteFile();
